import { onUnmounted } from 'vue';
import { debounce } from 'radash';
export const useWindowResize = (cb: () => void, delay: number = 100) => {
    let currentScreenWidth = window.document.documentElement.clientWidth;
    const onWindowResize = debounce({ delay, }, () => {
        if (window.document.documentElement.clientWidth !== currentScreenWidth) {
            currentScreenWidth = window.document.documentElement.clientWidth;
            cb();
        }
    });
    window.addEventListener('resize', onWindowResize);
    onUnmounted(() => {
        window.removeEventListener('resize', onWindowResize);
    });
};

export const useWXFontSizeReset = () => {
    // 向head节点插入script标签
    const script = document.createElement('script');
    script.innerHTML = `
        (function() {
            if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
                handleFontSize();
            } else {
                console.log('WeixinJSBridgeReady is bad');
                document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
            }
            function handleFontSize() {
                console.log('handleFontSize');
                // 设置网页字体为默认大小
                WeixinJSBridge.invoke("setFontSizeCallback", { "fontSize" : 0 });
                // 重写设置网页字体大小的事件
                WeixinJSBridge.on("menu:setfont", function() {
                    WeixinJSBridge.invoke("setFontSizeCallback", { "fontSize&" : 0 });
                });
            }
        })();
    `;
    document.head.appendChild(script);
}
